import React from "react";
import { Link } from "react-router-dom";

import { getAssetUrl } from "../config";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function NotFound() {
  return (
    <>
      <Header />
      <main>
        <section
          className="page-hero container"
          style={{ paddingBottom: "72px" }}
        >
          <Link to="/" className="not-found-logo">
            <img alt="Kudosta" src={getAssetUrl('kds-assets/img/final_logo.png')} />
          </Link>
          <h1 className="h-xl">
            4<span style={{ color: "var(--orange)" }}>0</span>4
          </h1>
          <h2>Page Not Found</h2>
          <br />
          <Link to="/" className="btn btn-primary">
            Back to Home
          </Link>
        </section>
      </main>
      <Footer />
    </>
  );
}
